import { COLORS } from 'Components/utils/color/colors';
import { Button } from 'Components/frameworks/button/Button';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import React from 'react';
import { t } from 'Src/i18n';
export const ModifyButton = ({
  hasPrice,
  formStep,
  setFormStep,
  resetProposal,
}: {
  hasPrice: boolean;
  formStep: number;
  setFormStep: (formStep: number) => void;
  resetProposal: () => void;
}) => {
  const { trackClickEvent } = useTrackEvent();

  const modifyAction = () => {
    let detailClick = '';

    if (formStep === 1) {
      detailClick = 'modify_stay_step';
    } else if (formStep === 2) {
      detailClick = 'modify_participants_step';
    } else {
      detailClick = hasPrice
        ? 'modify_estimation_step_with_price'
        : 'modify_estimation_step_without_price';
    }

    trackClickEvent(TRACK_EVENT_NAMES.CLICK_PREBOOKING_FORM_PREREG, {
      detail_click: detailClick,
    });
    resetProposal();
    setFormStep(0);
  };

  return (
    <Button
      key="prebooking-modify"
      id="prebooking-modify"
      className="mx-10"
      colorBg={COLORS.WHITE}
      colorBorder={COLORS.BLACK}
      onClick={modifyAction}
    >
      {t('prebookingForm.modifyRequest')}
    </Button>
  );
};
